import React, { useState } from 'react'
import { domPackage, intPackage } from './list'
import { Link } from 'react-router-dom'
import listIcon1 from '../../../assets/images/listIcon1.png'
import listIcon2 from '../../../assets/images/listIcon2.png'


const PackegeList = () => {

  const [hover, setHover] = useState('');
  const [intHover, setIntHover] = useState('')
  const [packageView, setPackageView] = useState('')

  return (
    <div className='packageList'>
      <h4>Our Package</h4>
      <div className='intDom' style={{ paddingBottom: 0 }}>
        <div className='domestic' onMouseEnter={() => setPackageView('Domestic')} onMouseLeave={() => setPackageView('')}>
          <Link class="card1" to="/packages/domestic">
            <h3>Domestic</h3>
            <div class="go-corner" href="#">
              <div class="go-arrow">
                →
              </div>
            </div>
          </Link>


        </div>
        <div className='international' onMouseEnter={() => setPackageView('International')} onMouseLeave={() => setPackageView('')}>
          <Link class="card2" to="/packages/international">
            <h3>International</h3>
            <div class="go-corner" href="#">
              <div class="go-arrow">
                →
              </div>
            </div>
          </Link>

        </div>
      </div>

      {packageView === "Domestic" ?
        <div className='domList' onMouseEnter={() => setPackageView('Domestic')} onMouseLeave={() => setPackageView('')}>
          <h4>Domestic Package</h4>
          <ul>
            {domPackage.map((item, index) =>
              <li onMouseEnter={() => setHover(index)} onMouseLeave={() => setHover('')}>
                {hover === index ? <img src={listIcon2} alt='icon2' /> : <img src={listIcon1} alt='icon1' />} <Link to={item.link} className='packLink'> {item.place} </Link>
              </li>
            )}
          </ul></div> : packageView === "International" ?
          <div className='intList' onMouseEnter={() => setPackageView('International')} onMouseLeave={() => setPackageView('')}>
            <h4>International Package</h4>
            <ul>
              {intPackage.map((item, index) =>
                <li onMouseEnter={() => setIntHover(index)} onMouseLeave={() => setIntHover('')}>
                  {intHover === index ? <img src={listIcon2} alt='icon2' /> : <img src={listIcon1} alt='icon1' />} <Link to={item.link} className='packLink'> {item.place} </Link>
                </li>
              )}
            </ul>
          </div> : ""}


    </div>
  )
}

export default PackegeList